/* svnty-viewer.js: THE VIEWER (D4-23, 2026-09-25). Classic, deferred, no deps, no console, ASCII.
 * Every picture of the product, all colors, every device (02:07). Replaces Trade's product media modal.
 * LAWS: Trade's contract show(opener)/hide() (modal-opener opens it from 750 px; data-media-id names the picture).
 * THE TAP, NEVER THE SWIPE on the phone (one finger, <300 ms, <8 px, never a hanger; no click after a swipe).
 * All colors, the picked one first in the hero's order, then the option order, untagged last (color from the alt).
 * THE PICTURE AS IS + NO-FADE (whole, contain; only backdrop and chrome animate). THE ONE HOLDER lock
 * (body.overflow-hidden), scroll put back exactly. The back button closes it; the X pops only our own entry. */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('svnty-viewer')) return;
  var PHONE = '(max-width: 749px), (pointer: coarse) and (orientation: landscape) and (max-height: 500px)';
  var MAX = 4, TAPZ = 2.5, PULL = 90;
  var slice = function (l) { return Array.prototype.slice.call(l); };
  var mq = function (q) { return window.matchMedia(q).matches; };
  var now = function (e) { return (e && e.timeStamp) || Date.now(); };

  /** clamp(v, a, b): v held inside [a, b]. */
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /** layoutNow(): 'phone' under 750 px or a landscape phone, 'desk' from 990 px, 'tablet' between. */
  function layoutNow() { return mq(PHONE) ? 'phone' : (mq('(min-width: 990px)') ? 'desk' : 'tablet'); }

  /** selectedColour(root): the checked Color value of the variant picker (svnty-colour-gallery.js's reading), else null. */
  function selectedColour(root) {
    /* THE COLOUR PIPELINE (D4-25): the page's colour is the bus's (assets/svnty-colour.js); the picker only without it */
    try { var bus = window.SVNTY && window.SVNTY.colour, st = bus && bus.get(); if (st && st.colour) return st.colour; } catch (e) {}
    var sel = (root && root.querySelector('variant-selects')) || document.querySelector('variant-selects');
    if (!sel) return null;
    var fs = sel.querySelectorAll('fieldset, .product-form__input');
    for (var i = 0; i < fs.length; i++) {
      if (!/colou?r/i.test(fs[i].getAttribute('data-svnty-option') || '')) continue;
      var c = fs[i].querySelector('input[type="radio"]:checked'), s = fs[i].querySelector('select');
      if (c) return c.value;
      if (s) return s.value;
    }
    return null;
  }

  /** focusables(root): the visible enabled controls inside root, in DOM order (the Tab trap). */
  function focusables(root) {
    return slice(root.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')).filter(function (el) {
      return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
    });
  }

  /** focusQuiet(el): focus without moving the page. */
  function focusQuiet(el) { if (!el || !el.focus) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }

  class SvntyViewer extends HTMLElement {
    /** connectedCallback(): moves to <body>; one viewer per id (an open twin wins); never in a quick add; wires once. */
    connectedCallback() {
      if (this._wired) return;
      if (this.closest('quick-add-modal, .quick-add-modal')) { this.remove(); return; }
      var self = this, keep = null;
      slice(document.querySelectorAll('svnty-viewer')).forEach(function (v) {
        if (v !== self && v.id === self.id) { if (v.isOpen) keep = v; else v.remove(); }
      });
      if (keep) { this.remove(); return; }
      if (this.parentNode !== document.body) { document.body.appendChild(this); return; }
      this._wired = true;
      this.wire();
    }

    /** disconnectedCallback(): a viewer taken out while open (a section re-render) gives the lock back. */
    disconnectedCallback() {
      if (!this.isOpen || this.parentNode) return;
      this.isOpen = false;
      document.body.classList.remove('overflow-hidden');
      if (Math.abs(window.pageYOffset - (this.savedY || 0)) > 1) window.scrollTo(0, this.savedY || 0);
    }

    /** wire(): finds the parts and binds every listener once. */
    wire() {
      var self = this, q = function (s) { return self.querySelector(s); }, on = function (el, ev, fn, passive) {
        el.addEventListener(ev, fn.bind(self), { passive: !!passive });
      };
      this.dialog = q('[role="dialog"]'); this.stage = q('[data-viewer-stage]'); this.track = q('[data-viewer-track]');
      this.box = q('[data-viewer-thumbs]'); this.countEl = q('[data-viewer-count]'); this.colourEl = q('[data-viewer-colour]');
      this.liveEl = q('[data-viewer-live]');
      this.closeBtn = q('[data-viewer-close]');
      this.slides = slice(this.track.children);
      this.order = this.slides.slice();
      this.thumbs = slice(this.box.querySelectorAll('.svnty-viewer__thumb'));
      try { this.colours = JSON.parse(this.getAttribute('data-colours') || '[]'); } catch (e) { this.colours = []; }
      if (!Array.isArray(this.colours)) this.colours = [];
      this.isOpen = false; this.index = 0;
      on(this.closeBtn, 'click', this.hide);
      on(this, 'keydown', this.onKey);
      on(this.box, 'click', function (e) {
        var b = e.target.closest('.svnty-viewer__thumb'), i = b ? this.order.indexOf(this.slideOf(b.getAttribute('data-media-id'))) : -1;
        if (i >= 0) { this.goTo(i, true); this.announce(i); }
      });
      on(this.stage, 'click', this.onStageClick);
      on(this.stage, 'mousemove', this.onMouseMove);
      on(this.stage, 'wheel', function () { this.unzoomDesk(); this.unpin(); }, true);
      on(this.stage, 'scroll', this.onStageScroll, true);
      on(this.track, 'scroll', this.onTrackScroll, true);
      on(this.track, 'touchstart', this.onTouchStart);
      on(this.track, 'touchmove', this.onTouchMove);
      on(this.track, 'touchend', this.onTouchEnd);
      on(this.track, 'touchcancel', this.onTouchEnd);
      /* THE WALL: no touchmove reaches the page or the header guard; native pans: strip, column */
      on(this, 'touchmove', function (e) {
        e.stopPropagation();
        var t = e.target, own = t.closest('[data-viewer-thumbs]') || (this.layout !== 'phone' && t.closest('[data-viewer-stage]'));
        if (e.cancelable && (!own || e.touches.length > 1)) e.preventDefault();
      });
      window.addEventListener('popstate', function () {
        if (self.backPending) { self.backPending = false; return; }
        if (self.isOpen) self.close(true);
      });
      window.addEventListener('resize', function () { if (self.isOpen) self.relayout(); }, { passive: true });
      /* THE COLOUR PIPELINE (D4-25): a colour change regroups (the new colour first); open, the picture on screen stays */
      document.addEventListener('svnty:colour', function () {
        var cur = self.isOpen ? self.order[self.index] : null;
        self.regroup();
        if (cur) { self.index = -1; self.goTo(Math.max(0, self.order.indexOf(cur)), false); }
      });
      if ('IntersectionObserver' in window) this.io = new IntersectionObserver(this.onIntersect.bind(this), { root: this.stage, rootMargin: '-50% 0px -50% 0px' });
    }

    /** slideOf(id): the slide for a media id (raw, or Trade's "section-id" form). */
    slideOf(id) {
      var raw = String(id || '').split('-').pop();
      return this.slides.filter(function (s) { return s.getAttribute('data-media-id') === raw; })[0] || null;
    }

    /** regroup(): orders the slides by color group, moves them, rebuilds the labelled thumbnail groups. */
    regroup() {
      var picked = selectedColour(this.openedBy && this.openedBy.closest ? this.openedBy.closest('.shopify-section') : null);
      var groups = {}, seen = [], names = [], media = this.slides, sec = this.id.replace(/^SvntyViewer-/, ''), shown = {};
      media.forEach(function (s) {
        var c = s.getAttribute('data-colour') || '';
        if (!groups[c]) { groups[c] = []; seen.push(c); }
        groups[c].push(s);
        /* THE STRIPE NAME (D8-8, R239): the name the server printed ("Blue stripe"); the key stays data-colour */
        if (c && !shown[c]) shown[c] = s.getAttribute('data-colour-name') || c;
      });
      var add = function (c) { if (groups[c] && names.indexOf(c) < 0) names.push(c); };
      if (picked) add(picked);
      this.colours.forEach(add);
      seen.forEach(function (c) { if (c) add(c); });
      add('');
      if (picked && groups[picked]) {
        var pos = {};
        slice(document.querySelectorAll('#MediaGallery-' + sec + ' .product__media-item')).forEach(function (li, k) {
          pos[String(li.getAttribute('data-media-id') || '').split('-').pop()] = k;
        });
        var key = function (s) { var id = s.getAttribute('data-media-id'); return id in pos ? pos[id] : 1e4 + media.indexOf(s); };
        groups[picked].sort(function (a, b) { return key(a) - key(b); });
      }
      var order = [], byId = {}, n = 0, box = this.box;
      names.forEach(function (c) { order = order.concat(groups[c]); });
      this.order = order;
      order.forEach(function (s) { this.track.appendChild(s); }, this);
      this.thumbs.forEach(function (t) { byId[t.getAttribute('data-media-id')] = t; });
      slice(box.querySelectorAll('.svnty-viewer__group')).forEach(function (g) { g.remove(); });
      var tC = this.getAttribute('data-thumb-label') || 'Picture [n] of [total], [color]';
      var tP = this.getAttribute('data-thumb-label-plain') || 'Picture [n] of [total]';
      names.forEach(function (c) {
        var g = document.createElement('div'), row = document.createElement('div');
        g.className = 'svnty-viewer__group'; g.setAttribute('role', 'group'); row.className = 'svnty-viewer__row';
        if (c) {
          var lab = document.createElement('p');
          lab.className = 'svnty-viewer__label'; lab.textContent = shown[c] || c;
          g.setAttribute('aria-label', shown[c] || c); g.appendChild(lab);
        }
        /* A-11 (D5-1): numbered within the colour, as the hero's pill counts ("2 | 5" there, "2 / 5 Black" here) */
        groups[c].forEach(function (s, k) {
          s._gi = k + 1; s._gn = groups[c].length;
          var t = byId[s.getAttribute('data-media-id')];
          if (!t) return;
          n += 1;
          t.setAttribute('aria-label', (c ? tC : tP).replace('[n]', s._gi).replace('[total]', s._gn).replace('[color]', shown[c] || c));
          row.appendChild(t);
        });
        g.appendChild(row); box.appendChild(g);
      });
    }

    /** show(opener): Trade's contract; opens at the opener's picture, locks, pushes history, focuses the X. */
    show(opener) {
      if (this.isOpen) return;
      this.openedBy = opener || null;
      this.dock(true);
      this.isOpen = true;
      this.savedY = window.pageYOffset || 0;
      this.regroup();
      var start = Math.max(0, this.order.indexOf(this.slideOf(opener && opener.getAttribute ? opener.getAttribute('data-media-id') : '')));
      this.layout = layoutNow();
      this.setAttribute('data-layout', this.layout);
      this.warm(start, true);
      document.body.classList.add('overflow-hidden');
      this.hidden = false;
      this.setAttribute('open', '');
      void this.offsetWidth; /* layout now, so the jump lands */
      this.index = -1;
      this.goTo(start, false);
      if (this.io) this.slides.forEach(function (s) { this.io.observe(s); }, this);
      try { history.pushState(Object.assign({}, history.state || {}, { svntyViewer: this.id }), ''); this.pushed = true; } catch (e) { this.pushed = false; }
      if (window.pauseAllMedia) window.pauseAllMedia();
      var self = this;
      requestAnimationFrame(function () { if (self.isOpen) focusQuiet(self.closeBtn); }); /* after the lock's claim */
    }

    /** dock(on): THE DOOR (STATUS BAR law): open, an absolute box in the header slab; closed, back to body. */
    dock(on) {
      var h = on && (document.querySelector('.header-wrapper .header') || document.querySelector('.header-wrapper'));
      if (h && this.parentElement !== h) h.appendChild(this);
      if (!on && this.parentElement !== document.body) document.body.appendChild(this);
      this.classList.toggle('svnty-door', !!h);
    }

    /** hide(): Trade's contract; closes as the X does. */
    hide() { this.close(false); }

    /** close(fromPop): unlocks, puts the page back, pops our own entry, focuses the opener. */
    close(fromPop) {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.gesture = null;
      this.unpin();
      if (this.io) this.io.disconnect();
      this.unzoomDesk();
      this.slides.forEach(function (s) { this.resetZoom(s, false); var im = s.querySelector('img'); if (im) im.style.transform = ''; }, this);
      this.classList.remove('is-pulling');
      this.style.removeProperty('--svnty-viewer-drag');
      this.removeAttribute('open');
      this.hidden = true;
      this.dock(false);
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      var y = this.savedY || 0, put = function () { if (Math.abs(window.pageYOffset - y) > 1) window.scrollTo(0, y); };
      put();
      if (!fromPop && this.pushed) {
        try { if (history.state && history.state.svntyViewer === this.id) { this.backPending = true; history.back(); } } catch (e) { /* no history */ }
      }
      this.pushed = false;
      /* A-10 (D5-1): the phone's toggle is a 0 x 0 button with no ring; focus its picture's slide instead, a visible target
         (from 750 px the toggle's own ::after is the picture-sized focus ring, so it keeps the focus) */
      var back = this.openedBy, r = back && back.getClientRects ? back.getClientRects()[0] : null;
      if (back && this.layout === 'phone' && (!r || r.width * r.height === 0)) {
        var item = back.closest && back.closest('.product__media-item');
        if (item) { if (!item.hasAttribute('tabindex')) item.setAttribute('tabindex', '-1'); back = item; }
      }
      focusQuiet(back);
      put();
    }

    /** warm(i, first): loads the picture and its neighbours now (high priority at open); the rest stay lazy. */
    warm(i, first) {
      for (var k = i - 2; k <= i + 2; k++) {
        var img = this.order[k] && this.order[k].querySelector('img');
        if (!img || (first && Math.abs(k - i) > 1)) continue;
        img.setAttribute('loading', 'eager');
        if (first) img.setAttribute('fetchpriority', 'high');
      }
      if (!first) return;
      this.thumbs.forEach(function (b) { var im = b.querySelector('img'); if (im) im.setAttribute('loading', 'eager'); });
      this.bridge(i);
    }

    /** bridge(i): the hero's cached copy shows under a loading picture (same contain box), removed once it loads. */
    bridge(i) {
      var sec = this.id.replace(/^SvntyViewer-/, '');
      for (var k = i - 1; k <= i + 1; k++) {
        var s = this.order[k], img = s && s.querySelector('img'), frame = s && s.querySelector('.svnty-viewer__frame');
        if (!img || !frame || (img.complete && img.naturalWidth)) continue;
        var hero = document.querySelector('#Slide-' + sec + '-' + s.getAttribute('data-media-id') + ' img');
        var src = hero && hero.complete && hero.naturalWidth ? (hero.currentSrc || hero.src) : '';
        if (!src) continue;
        frame.style.backgroundImage = 'url("' + src.replace(/"/g, '%22') + '")';
        img.addEventListener('load', function () { this.parentNode.style.backgroundImage = ''; }, { once: true });
      }
    }

    /** goTo(i, smooth): moves to picture i (the track on the phone, the column elsewhere) and marks it active. */
    goTo(i, smooth) {
      i = clamp(i, 0, this.order.length - 1);
      var s = this.order[i];
      if (!s) return;
      var b = smooth && !mq('(prefers-reduced-motion: reduce)') ? 'smooth' : 'auto';
      if (this.layout === 'phone') {
        this.track.classList.remove('is-free');
        var left = i * this.track.clientWidth;
        if (b === 'auto') this.track.scrollLeft = left; else this.track.scrollTo({ left: left, behavior: b });
      } else {
        this.unzoomDesk();
        this.pin(b === 'smooth' ? 900 : 250);
        var top = s.offsetTop - 12; /* at the gap */
        if (b === 'auto') this.stage.scrollTop = top; else this.stage.scrollTo({ top: top, behavior: b });
      }
      this.setActive(i, b !== 'smooth');
    }

    /** setActive(i, instant): counter, color, thumbnail ring kept in view; a left phone slide unzooms. */
    setActive(i, instant) {
      if (i === this.index) return;
      if (this.layout === 'phone') this.resetZoom(this.order[this.index], false);
      this.index = i;
      var s = this.order[i];
      if (!s) return;
      var id = s.getAttribute('data-media-id'), box = this.box, cur = null;
      this.countEl.textContent = (s._gi || i + 1) + ' / ' + (s._gn || this.order.length);
      this.colourEl.textContent = s.getAttribute('data-colour-name') || s.getAttribute('data-colour') || '';
      this.thumbs.forEach(function (t) {
        if (t.getAttribute('data-media-id') === id) { t.setAttribute('aria-current', 'true'); cur = t; } else t.removeAttribute('aria-current');
      });
      if (cur && box.getClientRects().length) {
        var r = box.getBoundingClientRect(), c = cur.getBoundingClientRect(), o = { behavior: instant ? 'auto' : 'smooth' };
        if (this.layout === 'desk') {
          if (c.top < r.top + 24 || c.bottom > r.bottom - 24) { o.top = box.scrollTop + c.top - r.top - r.height / 2 + c.height / 2; box.scrollTo(o); }
        } else if (c.left < r.left + 24 || c.right > r.right - 24) {
          o.left = box.scrollLeft + c.left - r.left - r.width / 2 + c.width / 2; box.scrollTo(o);
        }
      }
      this.warm(i, false);
    }

    /** announce(i): the one spoken line (A-12, D5-1): "Picture 2 of 5, Black", written only on a settled swipe, a key or a
        thumbnail, never on the column's scroll; the visible "n / N" is aria-hidden. */
    announce(i) {
      var s = this.order[i];
      if (!s || !this.liveEl) return;
      var c = s.getAttribute('data-colour-name') || s.getAttribute('data-colour') || '';
      var tpl = c ? (this.getAttribute('data-thumb-label') || 'Picture [n] of [total], [color]') : (this.getAttribute('data-thumb-label-plain') || 'Picture [n] of [total]');
      this.liveEl.textContent = tpl.replace('[n]', s._gi || i + 1).replace('[total]', s._gn || this.order.length).replace('[color]', c);
    }

    /** relayout(): a resize or rotation while open; the active picture stays. */
    relayout() {
      var i = Math.max(0, this.index);
      this.unzoomDesk();
      this.slides.forEach(function (s) { this.resetZoom(s, false); }, this);
      this.layout = layoutNow();
      this.setAttribute('data-layout', this.layout);
      this.index = -1;
      this.goTo(i, false);
    }

    /** onKey(e): Escape closes; arrows, Page and Home/End keys move; Tab stays inside the dialog. */
    onKey(e) {
      if (!this.isOpen) return;
      var k = e.key, step = { ArrowDown: 1, PageDown: 1, ArrowRight: 1, ArrowUp: -1, PageUp: -1, ArrowLeft: -1 }[k];
      if (k === 'Escape' || k === 'Esc') { e.preventDefault(); this.hide(); return; }
      if (k === 'Tab') {
        var f = focusables(this.dialog), a = document.activeElement;
        if (!f.length) { e.preventDefault(); return; }
        var to = e.shiftKey ? (a === f[0] || !this.contains(a) ? f[f.length - 1] : null) : (a === f[f.length - 1] || !this.contains(a) ? f[0] : null);
        if (to) { e.preventDefault(); to.focus(); }
        return;
      }
      if (k === 'Home' || k === 'End') { e.preventDefault(); this.goTo(k === 'Home' ? 0 : this.order.length - 1, true); this.announce(this.index); return; }
      if (!step) return;
      e.preventDefault();
      this.goTo(this.index + step, true);
      this.announce(this.index);
    }

    /* desk and tablet: the column */

    /** pin(ms): while a programmatic scroll runs, the middle-line observer may not move the ring. */
    pin(ms) { var self = this; clearTimeout(this.pinT); this.pinned = true; this.pinT = setTimeout(function () { self.pinned = false; }, ms); }

    /** unpin(): the observer rules again. */
    unpin() { clearTimeout(this.pinT); this.pinned = false; }

    /** onIntersect(entries): the picture crossing the stage's middle line is the active one. */
    onIntersect(entries) {
      if (!this.isOpen || this.layout === 'phone' || this.pinned) return;
      entries.forEach(function (en) { var i = this.order.indexOf(en.target); if (en.isIntersecting && i >= 0) this.setActive(i, false); }, this);
    }

    /** onStageScroll(): the column's ends (a short last picture never crosses the middle). */
    onStageScroll() {
      if (!this.isOpen || this.layout === 'phone' || this.pinned) return;
      var st = this.stage;
      if (st.scrollTop + st.clientHeight >= st.scrollHeight - 2) this.setActive(this.order.length - 1, false);
      else if (st.scrollTop <= 0) this.setActive(0, false);
    }

    /** onStageClick(e): a click zooms the picture 2 times toward the pointer; the next click unzooms. */
    onStageClick(e) {
      var s = this.layout !== 'phone' && e.target.closest('.svnty-viewer__slide'), img = s && s.querySelector('img');
      if (!img) return;
      var was = s === this.zoomedDesk;
      this.unzoomDesk();
      if (was) return;
      this.aim(s, img, e.clientX, e.clientY);
      img.setAttribute('sizes', '1946px'); /* the sharpest source for the close look */
      s.classList.add('is-zoomed');
      this.zoomedDesk = s;
    }

    /** aim(slide, img, x, y): the transform origin follows the pointer, so the zoomed picture pans without a drag. */
    aim(s, img, x, y) {
      var r = s.getBoundingClientRect();
      img.style.transformOrigin = (clamp((x - r.left) / (r.width || 1), 0, 1) * 100).toFixed(2) + '% ' + (clamp((y - r.top) / (r.height || 1), 0, 1) * 100).toFixed(2) + '%';
    }

    /** onMouseMove(e): pans the zoomed column picture with the mouse. */
    onMouseMove(e) { var s = this.zoomedDesk; if (s && this.layout !== 'phone') this.aim(s, s.querySelector('img'), e.clientX, e.clientY); }

    /** unzoomDesk(): the zoomed picture returns whole. */
    unzoomDesk() { if (this.zoomedDesk) this.zoomedDesk.classList.remove('is-zoomed'); this.zoomedDesk = null; }

    /* phone: the track and its gestures */

    /** onTrackScroll(): the counter follows the track, one reading per frame. */
    onTrackScroll() {
      if (!this.isOpen || this.layout !== 'phone' || this.raf) return;
      var self = this;
      this.raf = requestAnimationFrame(function () {
        self.raf = 0;
        self.setActive(clamp(Math.round(self.track.scrollLeft / (self.track.clientWidth || 1)), 0, self.order.length - 1), false);
      });
    }

    /** zoomOf(slide): the slide's zoom {s, x, y} (scale, px translation from its top left). */
    zoomOf(s) { return s._z || (s._z = { s: 1, x: 0, y: 0 }); }

    /** fit(slide, z): clamps the pan so the picture never leaves the screen empty (a smaller axis stays centred). */
    fit(s, z) {
      var W = s.clientWidth || 1, H = s.clientHeight || 1, ar = parseFloat(s.getAttribute('data-ar')) || 0.75;
      var iw = W / H > ar ? H * ar : W, ih = W / H > ar ? H : W / ar;
      var axis = function (t, i0, sz, S) { var w = z.s * sz; return w <= S ? (S - w) / 2 - z.s * i0 : clamp(t, S - z.s * (i0 + sz), -z.s * i0); };
      z.x = axis(z.x, (W - iw) / 2, iw, W);
      z.y = axis(z.y, (H - ih) / 2, ih, H);
    }

    /** paint(slide, ease): writes the zoom transform; a zoomed slide frees the track from snapping. */
    paint(s, ease) {
      var z = this.zoomOf(s), img = s.querySelector('img'), zoomed = z.s > 1.001;
      if (!img) return;
      img.classList.toggle('is-easing', !!ease);
      img.style.transform = zoomed || z.x || z.y ? 'translate3d(' + z.x.toFixed(2) + 'px,' + z.y.toFixed(2) + 'px,0) scale(' + z.s.toFixed(4) + ')' : '';
      s.classList.toggle('is-zoomed', zoomed);
      s.setAttribute('data-scale', z.s.toFixed(3));
      this.track.classList.toggle('is-free', zoomed);
      if (zoomed) img.setAttribute('sizes', '1946px');
    }

    /** resetZoom(slide, ease): the picture back to whole and centred. */
    resetZoom(s, ease) {
      if (!s || !s._z || (s._z.s === 1 && !s._z.x && !s._z.y)) return;
      s._z = { s: 1, x: 0, y: 0 };
      this.paint(s, ease);
    }

    /** local(slide, x, y): a screen point in the slide's own coordinates. */
    local(s, x, y) { var r = s.getBoundingClientRect(); return { x: x - r.left, y: y - r.top }; }

    /** mid(slide, e): the two fingers' midpoint (slide coordinates) and distance. */
    mid(s, e) {
      var a = e.touches[0], b = e.touches[1], m = this.local(s, (a.clientX + b.clientX) / 2, (a.clientY + b.clientY) / 2);
      m.d = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY) || 1;
      return m;
    }

    /** onTouchStart(e): a gesture begins: pinch (two fingers), pan (zoomed), else undecided. */
    onTouchStart(e) {
      var s = this.isOpen && this.layout === 'phone' && e.target.closest('.svnty-viewer__slide');
      if (!s) return;
      if (e.cancelable) e.preventDefault();
      var g = this.gesture, z = this.zoomOf(s), t = e.touches[0];
      if (e.touches.length >= 2) {
        if (!g || g.slide !== s) g = this.gesture = { slide: s };
        if (g.mode === 'track') this.settleTrack(g);
        if (g.mode === 'pull') this.springBack(g);
        var m = this.mid(s, e);
        g.mode = 'pinch'; g.d0 = m.d; g.s0 = z.s; g.px = (m.x - z.x) / z.s; g.py = (m.y - z.y) / z.s;
        return;
      }
      this.track.classList.add('is-free');
      this.gesture = { slide: s, mode: z.s > 1.001 ? 'pan' : null, x0: t.clientX, y0: t.clientY, t0: now(e), sl0: this.track.scrollLeft,
        zx: z.x, zy: z.y, lastX: t.clientX, lastT: now(e), vx: 0, moved: false };
      var img = s.querySelector('img');
      if (img) img.classList.remove('is-easing');
    }

    /** onTouchMove(e): pinch around the fingers, pan when zoomed, sideways drags the track, down pulls to close. */
    onTouchMove(e) {
      var g = this.gesture;
      if (!g || !this.isOpen) return;
      if (e.cancelable) e.preventDefault();
      var z = this.zoomOf(g.slide);
      if (g.mode === 'pinch') {
        if (e.touches.length < 2) return;
        var m = this.mid(g.slide, e);
        z.s = clamp(g.s0 * m.d / g.d0, 1, MAX); z.x = m.x - z.s * g.px; z.y = m.y - z.s * g.py;
        this.fit(g.slide, z); this.paint(g.slide, false);
        return;
      }
      var t = e.touches[0];
      if (!t) return;
      var dx = t.clientX - g.x0, dy = t.clientY - g.y0;
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) g.moved = true;
      if (g.mode === 'pan') { z.x = g.zx + dx; z.y = g.zy + dy; this.fit(g.slide, z); g.over = (g.zx + dx) - z.x; this.paint(g.slide, false); return; }
      if (g.mode === null) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        g.mode = Math.abs(dx) > Math.abs(dy) ? 'track' : (dy > 0 ? 'pull' : 'none');
      }
      if (g.mode === 'track') {
        var dt = now(e) - g.lastT;
        if (dt > 0) g.vx = (t.clientX - g.lastX) / dt;
        g.lastX = t.clientX; g.lastT = now(e);
        this.track.scrollLeft = g.sl0 - dx;
      } else if (g.mode === 'pull') {
        var img = g.slide.querySelector('img');
        g.pull = Math.max(0, dy);
        if (img) img.style.transform = 'translate3d(' + (dx * 0.25).toFixed(1) + 'px,' + g.pull.toFixed(1) + 'px,0)';
        this.classList.add('is-pulling');
        this.style.setProperty('--svnty-viewer-drag', clamp(g.pull / 320, 0, 1).toFixed(3));
      }
    }

    /** onTouchEnd(e): glide to a slide; pull past 90 px closes; pinch under 1.05 settles; double tap toggles 2.5x. */
    onTouchEnd(e) {
      var g = this.gesture;
      if (!g || !this.isOpen) return;
      if (e.cancelable) e.preventDefault(); /* no ghost click, no browser double tap zoom */
      var z = this.zoomOf(g.slide);
      if (g.mode === 'pinch') {
        if (e.touches.length === 1) {
          g.mode = z.s > 1.001 ? 'pan' : 'none'; g.x0 = e.touches[0].clientX; g.y0 = e.touches[0].clientY; g.zx = z.x; g.zy = z.y;
        } else if (!e.touches.length) {
          this.gesture = null;
          if (z.s < 1.05) { this.resetZoom(g.slide, true); this.track.classList.remove('is-free'); }
        }
        return;
      }
      if (e.touches.length) return;
      this.gesture = null;
      if (g.mode === 'track') { this.settleTrack(g); return; }
      if (g.mode === 'pull') { if ((g.pull || 0) > PULL) this.hide(); else this.springBack(g); return; }
      /* A-14 (D5-1): a zoomed picture panned on past its edge by a quarter of the screen leaves for its neighbour, as
         Photos does; the clamp in fit() measured the overshoot (g.over: + dragged right past the left edge) */
      if (g.mode === 'pan' && Math.abs(g.over || 0) > 0.25 * (g.slide.clientWidth || 1)) {
        var to = clamp(this.index + (g.over < 0 ? 1 : -1), 0, this.order.length - 1);
        if (to !== this.index) { this.resetZoom(g.slide, false); this.goTo(to, true); this.announce(to); return; }
      }
      var zoomed = z.s > 1.001, ct = e.changedTouches && e.changedTouches[0], last = this.lastTap;
      if (!zoomed) this.track.classList.remove('is-free');
      if (g.mode === 'none' || !ct || g.moved || now(e) - g.t0 > 300) { this.lastTap = null; return; }
      if (last && last.slide === g.slide && now(e) - last.t < 320 && Math.hypot(ct.clientX - last.x, ct.clientY - last.y) < 30) {
        this.lastTap = null;
        if (zoomed) { this.resetZoom(g.slide, true); this.track.classList.remove('is-free'); return; }
        var p = this.local(g.slide, ct.clientX, ct.clientY), cx = (p.x - z.x) / z.s, cy = (p.y - z.y) / z.s;
        z.s = TAPZ; z.x = p.x - TAPZ * cx; z.y = p.y - TAPZ * cy;
        this.fit(g.slide, z); this.paint(g.slide, true);
        return;
      }
      this.lastTap = { slide: g.slide, t: now(e), x: ct.clientX, y: ct.clientY };
    }

    /** settleTrack(g): glide to the nearest slide, or the next after a fast or long swipe. */
    settleTrack(g) {
      var w = this.track.clientWidth || 1, cur = this.track.scrollLeft, from = Math.round(g.sl0 / w), to = Math.round(cur / w), self = this;
      if (to === from && Math.abs(cur - g.sl0) > w * 0.12) to = from + (cur > g.sl0 ? 1 : -1);
      if (to === from && Math.abs(g.vx || 0) > 0.5) to = from + (g.vx < 0 ? 1 : -1);
      to = clamp(to, 0, this.order.length - 1);
      this.track.scrollTo({ left: to * w, behavior: 'smooth' });
      clearTimeout(this.snapT);
      this.snapT = setTimeout(function () {
        if (!self.gesture) { self.track.classList.remove('is-free'); self.track.scrollLeft = to * w; }
        self.setActive(to, false);
        self.announce(to);
      }, 380);
      this.setActive(to, false);
    }

    /** springBack(g): a short pull returns the picture and the chrome. */
    springBack(g) {
      var img = g.slide.querySelector('img');
      if (img) { img.classList.add('is-easing'); img.style.transform = ''; }
      this.classList.remove('is-pulling');
      this.style.removeProperty('--svnty-viewer-drag');
      this.track.classList.remove('is-free');
    }
  }

  customElements.define('svnty-viewer', SvntyViewer);

  /* THE TAP on the phone's hero */
  var tap = null, cap = function (ev, fn, passive) { document.addEventListener(ev, fn, { passive: passive, capture: true }); };

  /** heroItem(t): the hero image slide under a touch; never a hanger or a quick add. */
  function heroItem(t) {
    if (!t || !t.closest || t.closest('[data-svnty-hanger]')) return null;
    var item = t.closest('.product__media-wrapper .product__media-item');
    return item && !item.closest('quick-add-modal, .quick-add-modal') && item.querySelector('.product__modal-opener--image') ? item : null;
  }

  cap('touchstart', function (e) {
    var item = mq(PHONE) && e.touches.length === 1 ? heroItem(e.target) : null;
    tap = item ? { item: item, x: e.touches[0].clientX, y: e.touches[0].clientY, t: now(e), moved: false } : null;
  }, true);
  cap('touchmove', function (e) {
    var t = e.touches[0];
    if (tap && (!t || e.touches.length !== 1 || Math.hypot(t.clientX - tap.x, t.clientY - tap.y) >= 8)) tap.moved = true;
  }, true);
  cap('touchcancel', function () { tap = null; }, true);
  cap('touchend', function (e) {
    var p = tap, c = e.changedTouches && e.changedTouches[0];
    tap = null;
    if (!p || p.moved || e.touches.length || !c || Math.hypot(c.clientX - p.x, c.clientY - p.y) >= 8 || now(e) - p.t >= 300) return;
    var toggle = p.item.querySelector('.product__media-toggle'), opener = toggle && toggle.closest('modal-opener');
    var v = opener && document.querySelector(opener.getAttribute('data-modal'));
    if (!v || v.tagName !== 'SVNTY-VIEWER') return;
    if (e.cancelable) e.preventDefault(); /* the synthesized click must not land on the viewer that just opened */
    v.show(toggle);
  }, false);
})();
